export default {"src":"/hedera/_next/static/media/faq_dark.6ef72b12.svg","height":24,"width":24};